import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, Clock, ArrowLeft, Shield } from 'lucide-react';

const PaymentPendingPage = () => {
  return (
    <div data-testid="payment-pending-page" className="min-h-screen bg-[#FAFAF8] py-16">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-2xl">
        <div className="bg-white rounded-3xl p-8 md:p-12 border border-slate-100 text-center">
          <div className="w-20 h-20 bg-[#FFF3E0] rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="w-10 h-10 text-[#FF9F43]" />
          </div>
          
          <h1 className="text-2xl md:text-3xl font-['Poppins'] font-bold text-[#2D3748] mb-4">
            Mokėjimų sistema ruošiama
          </h1>
          
          <p className="text-[#718096] mb-8">
            Šiuo metu vyksta mokėjimų sistemos integracijos procesas su Paysera. 
            Mokėjimai bus prieinami labai greitai!
          </p>

          <div className="bg-[#E8F5E9] rounded-2xl p-6 mb-8">
            <div className="flex items-center justify-center space-x-2 mb-3">
              <Shield className="w-5 h-5 text-[#4CAF50]" />
              <span className="font-semibold text-[#2D3748]">Saugūs mokėjimai su Paysera</span>
            </div>
            <p className="text-sm text-[#718096]">
              Naudojame patikimą Paysera mokėjimo sistemą, kuri užtikrina saugų ir patogų apmokėjimą.
            </p>
          </div>

          <div className="space-y-4">
            <p className="text-sm text-[#718096]">
              Norėdami įsigyti produktus dabar, susisiekite tiesiogiai:
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="mailto:info@tavoemocijos.lt"
                className="inline-flex items-center justify-center bg-[#4CAF50] text-white hover:bg-[#43A047] rounded-full px-6 py-3 font-semibold transition-colors"
              >
                <CreditCard className="w-5 h-5 mr-2" />
                Rašyti el. laišką
              </a>
              <Link
                to="/parduotuve"
                className="inline-flex items-center justify-center bg-white text-[#4CAF50] border-2 border-[#4CAF50] hover:bg-[#E8F5E9] rounded-full px-6 py-3 font-semibold transition-colors"
              >
                <ArrowLeft className="w-5 h-5 mr-2" />
                Grįžti į parduotuvę
              </Link>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-slate-100">
            <p className="text-xs text-[#718096]">
              Pardavėjas: Dmitrij Borodin | Ind. veiklos pažymos nr. 706574<br/>
              El. paštas: info@tavoemocijos.lt | Tel.: +370 678 38321
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPendingPage;
